import React from 'react'
import { useEffect, useState, useRef } from "react";
import AnimatedLetters from '../AnimatedLetters/AnimatedLetters'
import './Project.scss'
import { Outlet } from 'react-router-dom'
import hulu4 from '../../assets/project/hulu-4.png'
import spFF from '../../assets/project/spotify-FF.png'
import pfC from '../../assets/project/ca.png'
import bwe from '../../assets/project/bwe.png'
import refrain from "../../assets/project/refrain.png";
import mediSync from "../../assets/project/mediSync.png";
import groupPat from "../../assets/project/groupPat.png";
import markMyFace from "../../assets/project/markMyFace.png";
import eventMmt from "../../assets/project/eventMmt.png";
import dClock from "../../assets/project/dClock.png";

function Project() {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3300)
  }, [])

const scrollableRef = useRef(null);
const [isScrolling, setIsScrolling] = useState(true);

useEffect(() => {
  const scrollableElement = scrollableRef.current;

  const scrollContent = () => {
    if (isScrolling) {
      if (scrollableElement.scrollTop >= scrollableElement.scrollHeight / 2) {
        scrollableElement.scrollTop = 0;
      } else {
        scrollableElement.scrollTop += 1;
      }
    }
  };

  const intervalId = setInterval(scrollContent, 20);

  const handleMouseEnter = () => setIsScrolling(false);
  const handleMouseLeave = () => setIsScrolling(true);

  scrollableElement.addEventListener("mouseenter", handleMouseEnter);
  scrollableElement.addEventListener("mouseleave", handleMouseLeave);

  return () => {
    clearInterval(intervalId);
    scrollableElement.removeEventListener("mouseenter", handleMouseEnter);
    scrollableElement.removeEventListener("mouseleave", handleMouseLeave);
  };
}, [isScrolling]);


  return (
    <>
      <div className="container project-page">
        <div className="page">
          <span className="tags top-html">&lt;/html&gt;</span>
          <span className="tags top-tags">&lt;body&gt;</span>

          <div className="text-zone">
            <h1>
              <AnimatedLetters
                letterClass={letterClass}
                strArray={[
                  "M",
                  "y",
                  " ",
                  "P",
                  "r",
                  "o",
                  "j",
                  "e",
                  "c",
                  "t",
                  "s",
                ]}
                idx={15}
              />
            </h1>
            <p>
              I specialize in crafting full-stack applications that balance
              elegant user experiences with strong backend engineering. With a
              foundation in Computer Science and hands-on development
              experience, I’ve built scalable web platforms, AI-integrated
              systems, and performance-driven applications using modern
              technologies and best engineering practices.
              <br />
              <br />
              Each project reflects my emphasis on clarity in design, efficiency
              in execution, and real-world problem solving.
              <br />
              <br />
              As a Software Engineer and Computer Science graduate, I've worked
              on multiple projects during my course based out of development /
              Web Applications / Frontend / Backend.
              <br />
              <br />
              This is a fresh selection of my latest projects!
              <br />
              <a
                href="https://github.com/LakshaySK106"
                target="_blank"
                rel="noreferrer"
                className="qView"
              >
                Wanna take a quick view?
              </a>
            </p>
          </div>
          <div
            id="home-magicwall"
            className="fake-magicwall auto-scroll"
            ref={scrollableRef}
          >
            {[...Array(50)].map((_, i) => (
              <React.Fragment key={i}>
                <div className="magic-wall_item">
                  <a
                    href="https://huloo-clone.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={hulu4} alt="okimage" />
                  </a>
                </div>
                <div className="magic-wall_item">
                  <a
                    href="https://spotify-now-playing-gold-seven.vercel.app/api/now-playing"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={spFF} alt="okimage" />
                  </a>
                </div>
                <div className="magic-wall_item">
                  <a
                    href="https://refrain-addiction.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={refrain} alt="okimage" />
                  </a>
                </div>{" "}
                <div className="magic-wall_item">
                  <a
                    href="https://group-patronage-plat.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={groupPat} alt="okimage" />
                  </a>
                </div>
                <div className="magic-wall_item">
                  <a
                    href="https://codes-anywhere.herokuapp.com/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={pfC} alt="okimage" />
                  </a>
                </div>
                <div className="magic-wall_item">
                  <a
                    href="https://github.com/LakshaySK106/Blocking-Web-ETE"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={bwe} alt="okimage" />
                  </a>
                </div>
                <div className="magic-wall_item">
                  <a
                    href="https://bnb-phr.netlify.app/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={mediSync} alt="okimage" />
                  </a>
                </div>
                <div className="magic-wall_item">
                  <a
                    href="https://github.com/LakshaySK106/markMyFace"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={markMyFace} alt="okimage" />
                  </a>
                </div>
                <div className="magic-wall_item">
                  <a
                    href="https://github.com/LakshaySK106/Digital-Clock"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={dClock} alt="okimage" />
                  </a>
                </div>
                <div className="magic-wall_item">
                  <a
                    href="https://github.com/LakshaySK106/Event-Management-System"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={eventMmt} alt="okimage" />
                  </a>
                </div>
              </React.Fragment>
            ))}
          </div>
          <Outlet />
          <span className="tags bottom-tags">
            &lt;/body&gt;
            <br />
            <span className="bottom-tag-html">&lt;/html&gt;</span>
          </span>
        </div>
      </div>
    </>
  );
}

export default Project